"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3.8 12.18c-.2-.86-.3-1.76-.3-2.68 0-2.84.99-5.45 2.63-7.5L7.2 3.07C5.82 4.85 5 7.08 5 9.5c0 .88.11 1.74.32 2.56l1.62-1.62L8 11.5 4.5 15 1 11.5l1.06-1.06zm17.91-1 2.09 7.39-8.23 3.65-6.84-2.85.61-1.62 3.8-.75-4.35-9.83c-.34-.76 0-1.64.76-1.98s1.64 0 1.98.76l2.43 5.49 1.26-.56z"
}), 'SwipeDownSharp');